// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

import feeds from './entity-feeds.js';

export default [
    {
        path: '/:organisation/crm/entities/import',
        component: () =>
            import('@/pages/[organisation]/crm/entities/import.vue'),
        name: 'crm.entities.import-entity-csv',
        meta: {
            loginRequired: true,
            permission: 'access.crm.contacts.create-entity',
        },
    },

    {
        path: '/:organisation/crm/entities/archive',
        component: () =>
            import('@/pages/[organisation]/crm/entities/archive.vue'),
        name: 'crm.entities.archived-entities',
        meta: {
            loginRequired: true,
            permission: 'access.crm.contacts.update-entity',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/crm/entities/archive/[id].vue'),
                name: 'crm.entities.view-archived-entity',
                meta: {
                    loginRequired: true,
                    permission: 'access.crm.contacts.update-entity',
                },
            },
        ],
    },

    {
        path: '/:organisation/crm/entities',
        component: () =>
            import('@/pages/[organisation]/crm/entities/index.vue'),
        name: 'crm.entities.search-entities',
        meta: {
            loginRequired: true,
            permission: 'access.crm.contacts.view-entities',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/crm/entities/new.vue'),
                name: 'crm.entities.create-entity',
                meta: {
                    loginRequired: true,
                    permission: 'access.crm.contacts.create-entity',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/crm/entities/[id].vue'),
                name: 'crm.entities.view-entity',
                meta: {
                    loginRequired: true,
                    permission: 'access.crm.contacts.view-entities',
                },
                children: [...feeds],
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/crm/entities/[id]/edit.vue'),
                name: 'crm.entities.update-entity',
                meta: {
                    loginRequired: true,
                    permission: 'access.crm.contacts.update-entity',
                },
            },
        ],
    },
];
